export const baseUrl = "http://127.0.0.1:8000/api/";
export const mediaUrl = "http://127.0.0.1:8000/storage/uploads/";
